@if (currentMode === FieldMode.READ && !isCreatingEntity) {
  <div class="read-field-container">
    <div [hidden]="!viewToggled"
         [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition) || !preconditionsForEdition}"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span #tooltip="matTooltip" (click)="onClickTooltip(tooltip)"
                [matTooltip]="fieldConfig.tooltip" matTooltipPosition="below">
            <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
          </span>
        }
      </div>
      <div class="field-container clickable-field fx-flex-100-66-percent fx-layout-col">
        <div (click)="onActivate($event)" (keyup.enter)="onActivate($event)"
             [ngClass]="{'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition,
                        'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)}"
             tabindex="0">
          <a (click)="navigateToEntitySheet()">
            {{ getFieldValue()?.displayName | emptyFieldPipe: {blankFieldValue: appConfig.EMPTY_FIELD_VALUE} }}
          </a>
          @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
            <span
              class="overlay-icon">
              @if (preconditionsForEdition) {
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil" class="selectable"></mat-icon>
              } @else {
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil-off" [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate" class="tooltip-icon"></mat-icon>
              }
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (currentMode === FieldMode.EDIT || isCreatingEntity) {
  <div>
    <div [hidden]="!editToggled || !viewToggled"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span #tooltip="matTooltip" (click)="onClickTooltip(tooltip)"
                  [matTooltip]="fieldConfig.tooltip">
              <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
            </span>
          }
        </div>
      }
      @if (preconditionsForEdition) {
        <div class="field-container fx-flex-100-66-percent-min-500 fx-layout-col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'LABEL.ASSET' | translate }}</mat-label>
            <mat-select-asset-autocomplete #inputField [disabled]="(asyncPreconditionsForEdition$ | async) === false"
                                           [required]="fieldConfig.customOptions?.required"
                                           [allowedEntityIds]="allowedEntityIds"
                                           [formControl]="form.controls.field">
            </mat-select-asset-autocomplete>
            @if ((asyncPreconditionsForEdition$ | async) === false) {
              <mat-hint>
                {{ 'VALIDATION.WORK_HAS_RELATED_EQUIPMENT' | translate }}
              </mat-hint>
            }
            @for (validator of erroredValidators; track validator.type) {
              <mat-error>
                {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
              </mat-error>
            }
            @if (isCreatingEntity && fieldConfig.tooltip) {
              <span matTextSuffix matTooltipPosition="below"
                    [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
                <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
              </span>
            }
          </mat-form-field>
          @if (isSingleField) {
            <div class="save-options">
              <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)" class="button">
                <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
              </button>
              <button (click)="onClickSave()" (keyup.escape)="onEscapeCancel($event)" [disabled]="!form.valid"
                      class="button save">
                <mat-icon fontSet="mdi" fontIcon="mdi-check"></mat-icon>
              </button>
            </div>
          }
        </div>
      } @else {
        <div class="field-container clickable-field fx-flex-100-66-percent-min-500 fx-layout-col">
          <div
            [ngClass]="{'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition}"
            tabindex="0">
            <a (click)="navigateToEntitySheet()">
              {{ getFieldValue()?.displayName  | emptyFieldPipe: {blankFieldValue: appConfig.EMPTY_FIELD_VALUE} }}
            </a>
            @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
              <span class="overlay-icon">
                <mat-icon fontSet="mdi" fontIcon="mdi-pencil-off" class="tooltip-icon"></mat-icon>
              </span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
